module.exports = __webpack_public_path__ + "static/media/GroundingTechniques.6490df25.mp3";